import styled from 'styled-components';

const LogoWrapper = styled.div`
  float: left;
`;

export default LogoWrapper;


// WEBPACK FOOTER //
// ./src/components/Header/LogoWrapper.js